import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { GoldButton } from './GoldButton';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-navy-900" data-id="element-208">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-209">
        <AnimatedSection className="text-center" data-id="element-210">
          <AnimatedItem data-id="element-211">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-212">
              Obtén el sistema completo{' '}
              <span className="text-gold-400" data-id="element-213">Plan Retiro</span> hoy mismo
            </h2>
          </AnimatedItem>

          <AnimatedItem data-id="element-214">
            <p className="mt-4 text-base md:text-lg text-slate-300 font-body leading-relaxed max-w-2xl mx-auto" data-id="element-215">
              Empieza a construir la jubilación que el sistema tradicional no te
              puede dar.
            </p>
          </AnimatedItem>

          {/* Price card */}
          <AnimatedItem data-id="element-216">
            <motion.div className="mt-10 mx-auto max-w-md p-8 md:p-10 rounded-2xl bg-gradient-to-b from-navy-700 to-navy-800 border border-gold-500/25 shadow-2xl shadow-gold-500/5 relative overflow-hidden" whileHover={{
            y: -2
          }} transition={{
            duration: 0.3
          }} data-id="element-217">
              {/* Decorative corner glow */}
              <div className="absolute -top-12 -right-12 w-32 h-32 bg-gold-500/10 rounded-full blur-[60px] pointer-events-none" data-id="element-218" />

              <div className="relative" data-id="element-219">
                {/* Product image */}
                <img src="https://cdn.magicpatterns.com/uploads/h47cBGRpt9ZRDhoC7w7mF9/heylloyd-image-1773431506947_Mockup_Plan_Retiro_3.png" alt="Plan Retiro - Guía digital" className="w-48 mx-auto mb-6 rounded-lg shadow-lg" data-id="element-220" />

                <span className="inline-block px-4 py-1.5 mb-4 text-xs font-body font-bold tracking-wider uppercase bg-emerald-500/15 text-emerald-400 border border-emerald-500/25 rounded-full" data-id="element-221">
                  78% de descuento
                </span>

                <p className="text-slate-400 font-body text-sm uppercase tracking-wider mb-2" data-id="element-222">
                  Inversión única
                </p>

                <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-223">
                  <span className="font-display text-2xl text-slate-500 line-through" data-id="element-224">
                    $29
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-1 mb-6" data-id="element-225">
                  <span className="font-display text-5xl md:text-6xl font-bold text-gold-400" data-id="element-226">
                    $6.39
                  </span>
                  <span className="text-slate-400 font-body text-lg" data-id="element-227">USD</span>
                </div>

                <GoldButton className="w-full text-base" data-id="element-228">
                  Quiero Mi Plan Retiro Ahora
                </GoldButton>

                <div className="mt-6 flex flex-col items-center gap-3" data-id="element-229">
                  <div className="flex items-center gap-2 text-slate-400 text-xs font-body" data-id="element-230">
                    <ZapIcon className="w-3.5 h-3.5 text-gold-400" aria-hidden="true" data-id="element-231" />
                    <span data-id="element-232">Acceso inmediato tras la compra</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-400 text-xs font-body" data-id="element-233">
                    <LockIcon className="w-3.5 h-3.5 text-gold-400" aria-hidden="true" data-id="element-234" />
                    <span data-id="element-235">Pago seguro y encriptado</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-400 text-xs font-body" data-id="element-236">
                    <ShieldCheckIcon className="w-3.5 h-3.5 text-gold-400" aria-hidden="true" data-id="element-237" />
                    <span data-id="element-238">Garantía de satisfacción</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatedItem>
        </AnimatedSection>
      </div>
    </section>;
}